/** @jsx jsx */
/* eslint-disable no-use-before-define */
import { jsx } from '@emotion/core'
import { sectionCss } from './style'
import React from 'react'
import { getState, trackPage } from '../twd'
import Managing from './managing'
import Terms from './terms'
import Trading from './trading'
import Searching from './searching'
import Starting from './starting'

const state = getState('faq', {
    tab: 'terms',
})

export default ({view=''} ={}) => {

    trackPage('faq')

    let t = view.split('.')[1] || ''
    const [tab, setTab_] = React.useState(t || state.value.tab || 'terms')
    const setTab = React.useCallback((m) => {
        state.set({tab:m})
        setTab_(m)
    }, [])


    return (
        <React.Fragment>
        <div className="container vertical-offset-sm" css={sectionCss}>
            <h3 className="medium-header" style={{marginBottom:'0px'}}>Frequently asked questions</h3>

            <div className="row"><div className="col-xs-12 vertical-offset-sm">
            <div
                data-name="faq-nav-tabs"
                className="nav-tabs">
            <ul>
                <li className={tab==='terms' ? 'active' : ''}>
                <button
                    data-name="faq-common-bond-terms-to-know"
                    className="subhead"
                    onClick={() => setTab('terms')}>Common bond terms to know</button>
                </li>

                <li className={tab==='starting' ? 'active' : ''}>
                <button
                    data-name="faq-getting-started"
                    className="subhead"
                    onClick={() => setTab('starting')}>Getting Started: Bond Fundamentals</button>
                </li>

                <li className={tab==='trading' ? 'active' : ''}>
                <button
                    data-name="faq-trading-bonds-at-etrade"
                    className="subhead"
                    onClick={() => setTab('trading')}>Trading Bonds at E*TRADE</button>
                </li>

                <li className={tab==='searching' ? 'active' : ''}>
                <button
                    data-name="faq-searching-for-bonds"
                    className="subhead"
                    onClick={() => setTab('searching')}>Searching for bonds</button>
                </li>

                <li className={tab==='managing' ? 'active' : ''}>
                <button
                    data-name="faq-managing-bond-holding"
                    className="subhead"
                    onClick={() => setTab('managing')}>Managing bond holdings</button>
                </li>
            </ul>
            </div>
            </div></div>

            <div className="row vertical-offset-sm">
            <div className="col-md-2 col-xs-1"></div>
            <div className="col-md-8 col-xs-10">
                {tab==='terms' && <Terms />}
                {tab==='starting' && <Starting />}
                {tab==='trading' && <Trading />}
                {tab==='searching' && <Searching />}
                {tab==='managing' && <Managing />}
            </div>
            <div className="col-md-2 col-xs-1"></div>
            </div>
        </div>
        </React.Fragment>)
}




// WEBPACK FOOTER //
// ./src/faq/faq.js